/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassAttendanceRef,
  UnifiedClassAttendanceRefOptional,
  UnifiedClassAttendanceRefMetaI,
  UnifiedClassAttendanceRefTrackedI,
} from "./unified-class-attendance-ref";
import {
  UnifiedClassAttendanceRefTracked,
  UnifiedClassAttendanceRefMeta,
} from "./unified-class-attendance-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassInstanceRef,
  UnifiedClassInstanceRefOptional,
  UnifiedClassInstanceRefMetaI,
  UnifiedClassInstanceRefTrackedI,
} from "./unified-class-instance-ref";
import {
  UnifiedClassInstanceRefTracked,
  UnifiedClassInstanceRefMeta,
} from "./unified-class-instance-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassSessionFull,
  UnifiedClassSessionFullOptional,
  UnifiedClassSessionFullMetaI,
  UnifiedClassSessionFullTrackedI,
} from "./unified-class-session-full";
import {
  UnifiedClassSessionFullTracked,
  UnifiedClassSessionFullMeta,
} from "./unified-class-session-full";

/**
 *
 * @export
 * @interface UnifiedClassSessionInternal
 */
export interface UnifiedClassSessionInternalOptional extends UnifiedClassSessionFullOptional {
  /**
   *
   * @type {number}
   * @memberof UnifiedClassSessionInternal
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof UnifiedClassSessionInternal
   */
  sessionDatetime?: Date;
  /**
   *
   * @type {UnifiedClassInstanceRef}
   * @memberof UnifiedClassSessionInternal
   */
  instanceId?: UnifiedClassInstanceRefOptional;
  /**
   *
   * @type {Array<UnifiedClassAttendanceRef>}
   * @memberof UnifiedClassSessionInternal
   */
  attendance?: UnifiedClassAttendanceRefOptional[];
}

export interface UnifiedClassSessionInternal
  extends UnifiedClassSessionInternalOptional, UnifiedClassSessionFull {
  /**
   *
   * @type {number}
   * @memberof UnifiedClassSessionInternal
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof UnifiedClassSessionInternal
   */
  sessionDatetime?: Date;
  /**
   *
   * @type {UnifiedClassInstanceRef}
   * @memberof UnifiedClassSessionInternal
   */
  instanceId?: UnifiedClassInstanceRef;
  /**
   *
   * @type {Array<UnifiedClassAttendanceRef>}
   * @memberof UnifiedClassSessionInternal
   */
  attendance?: UnifiedClassAttendanceRef[];
}

export interface UnifiedClassSessionInternalTrackedI extends UnifiedClassSessionFullOptional {
  /**
   *
   * @type {number}
   * @memberof UnifiedClassSessionInternal
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof UnifiedClassSessionInternal
   */
  sessionDatetime?: Date;
  sessionDatetimeIsSet: boolean;
  /**
   *
   * @type {UnifiedClassInstanceRef}
   * @memberof UnifiedClassSessionInternal
   */
  instanceId?: UnifiedClassInstanceRefTrackedI;
  instanceIdIsSet: boolean;
  /**
   *
   * @type {Array<UnifiedClassAttendanceRef>}
   * @memberof UnifiedClassSessionInternal
   */
  attendance?: UnifiedClassAttendanceRefTrackedI[];
  attendanceIsSet: boolean;
}

transformDatesMap.set(
  "UnifiedClassSessionInternal",
  function (model: UnifiedClassSessionInternal) {
    if (typeof model.sessionDatetime == "string")
      model.sessionDatetime = new Date(model.sessionDatetime);
    const transformDatesinstanceId = transformDatesMap.get(
      "UnifiedClassInstanceRef",
    );
    if (transformDatesinstanceId && model.instanceId) {
      transformDatesinstanceId(model.instanceId);
    }
    const transformDatesattendance = transformDatesMap.get(
      "UnifiedClassAttendanceRef",
    );
    if (transformDatesattendance) {
      model.attendance?.forEach((sub) => {
        transformDatesattendance(sub);
      });
    }
  },
);

export type UnifiedClassSessionInternalMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  sessionDatetime: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  instanceId: PropertyMeta<UnifiedClassInstanceRefMetaI>;
  //isDate: false
  //isDatetime: false
  attendance: PropertyMeta<UnifiedClassAttendanceRefMetaI>;
}>;

export var UnifiedClassSessionInternalMeta: UnifiedClassSessionInternalMetaI =
  {} as UnifiedClassSessionInternalMetaI;
UnifiedClassSessionInternalMeta = typeMeta("UnifiedClassSessionInternal", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  sessionDatetime: propertyMeta(
    "sessionDatetime",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  instanceId: propertyMeta(
    "instanceId",
    false,
    false,
    false,
    UnifiedClassInstanceRefMeta,
  ),
  attendance: propertyMeta(
    "attendance",
    true,
    false,
    false,
    UnifiedClassAttendanceRefMeta,
  ),
});

const metaI = UnifiedClassSessionInternalMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([UnifiedClassSessionFullMeta]);
  metaI.assignId.inheritedFrom = UnifiedClassSessionFullMeta.assignId;
  metaI.sessionDatetime.inheritedFrom =
    UnifiedClassSessionFullMeta.sessionDatetime;
});

export class UnifiedClassSessionInternalTracked
  extends UnifiedClassSessionFullTracked
  implements UnifiedClassSessionInternalTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  sessionDatetime__I?: Date = undefined;
  sessionDatetimeIsSet: boolean = false;
  set sessionDatetime(v: undefined | Date) {
    if (v !== undefined) {
      this.sessionDatetime__I = v;
      this.sessionDatetimeIsSet = true;
    } else {
      this.sessionDatetime__I = v || undefined;
      this.sessionDatetimeIsSet = false;
    }
    this.changeTracker = true;
  }
  get sessionDatetime() {
    return this.sessionDatetime__I;
  }
  instanceId__I?: UnifiedClassInstanceRefTracked = undefined;
  instanceIdIsSet: boolean = false;
  set instanceId(v: undefined | UnifiedClassInstanceRefTracked) {
    if (v !== undefined) {
      this.instanceId__I = v;
      this.instanceIdIsSet = true;
    } else {
      this.instanceId__I = v || undefined;
      this.instanceIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get instanceId() {
    return this.instanceId__I;
  }
  attendance__I?: UnifiedClassAttendanceRefTracked[] = undefined;
  attendanceIsSet: boolean = false;
  set attendance(v: undefined | UnifiedClassAttendanceRefTracked[]) {
    if (v !== undefined) {
      this.attendance__I = v;
      this.attendanceIsSet = true;
    } else {
      this.attendance__I = v || undefined;
      this.attendanceIsSet = false;
    }
    this.changeTracker = true;
  }
  get attendance() {
    return this.attendance__I;
  }
  constructor(
    config?: UnifiedClassSessionInternalOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.instanceId?.setIds();

    this.attendance?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: UnifiedClassSessionInternalOptional,
    options?: AssignOptions,
  ): UnifiedClassSessionInternalTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.sessionDatetime &&
      this.sessionDatetimeApplyFilter(optionsRequired.filter)
    ) {
      this.sessionDatetime = config.sessionDatetime;
      if (optionsRequired.unassign) this.sessionDatetimeIsSet = false;
      else this.sessionDatetimeIsSet = true;
    }
    if (
      config.instanceId &&
      this.instanceIdApplyFilter(optionsRequired.filter)
    ) {
      this.instanceId = new UnifiedClassInstanceRefTracked(
        config.instanceId,
        options,
      );
      if (optionsRequired.unassign) this.instanceIdIsSet = false;
      else this.instanceIdIsSet = true;
    }
    if (
      config.attendance &&
      this.attendanceApplyFilter(optionsRequired.filter)
    ) {
      this.attendance = config.attendance?.map(
        (a) => new UnifiedClassAttendanceRefTracked(a, options),
      );
      if (optionsRequired.unassign) this.attendanceIsSet = false;
      else this.attendanceIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): UnifiedClassSessionInternalTrackedI {
    const cloned = {} as UnifiedClassSessionInternalTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.sessionDatetimeIsSetDeep() &&
      this.sessionDatetimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sessionDatetimeIsSet = true;
      cloned.sessionDatetime = this.sessionDatetime;
    } else {
      //cloned.sessionDatetimeIsSet = false
    }
    if (
      this.instanceIdIsSetDeep() &&
      this.instanceIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.instanceIdIsSet = true;
      cloned.instanceId = this.instanceId?.removeUnset(filter);
    } else {
      //cloned.instanceIdIsSet = false
    }
    if (
      this.attendanceIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.attendanceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.attendanceIsSet = true;
      cloned.attendance = this.attendance
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.attendanceIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): UnifiedClassSessionInternalTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.sessionDatetimeApplyFilter(filter))
      this.sessionDatetimeIsSet = false;

    if (!this.instanceIdApplyFilter(filter)) this.instanceIdIsSet = false;
    this.instanceId?.unassignAll(filter);

    if (!this.attendanceApplyFilter(filter)) this.attendanceIsSet = false;

    this.attendance?.forEach((a) => a.unassignAll(filter));
    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassSessionInternalMeta.assignId,
      UnifiedClassSessionInternalMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  sessionDatetimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassSessionInternalMeta.sessionDatetime,
      UnifiedClassSessionInternalMeta,
      this.sessionDatetime,
      this,
    );
  }
  sessionDatetimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sessionDatetimeIsSet && this.sessionDatetimeApplyFilter(filter))
      return true;

    return false;
  }
  instanceIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassSessionInternalMeta.instanceId,
      UnifiedClassSessionInternalMeta,
      this.instanceId,
      this,
    );
  }
  instanceIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.instanceIdIsSet && this.instanceIdApplyFilter(filter)) return true;
    return this.instanceId?.anySet(filter) == true;

    return false;
  }
  attendanceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassSessionInternalMeta.attendance,
      UnifiedClassSessionInternalMeta,
      this.attendance,
      this,
    );
  }
  attendanceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.attendanceIsSet && this.attendanceApplyFilter(filter)) return true;

    return this.attendance?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.sessionDatetimeIsSetDeep(filter)) return true;
    if (this.instanceIdIsSetDeep(filter)) return true;
    if (this.attendanceIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
